// extracted by mini-css-extract-plugin
module.exports = {"Temp":"HeaterCtrl_Temp__1rjiU","Switch":"HeaterCtrl_Switch__WQGWJ","Canvas1":"HeaterCtrl_Canvas1__3kQwt","Canvas2":"HeaterCtrl_Canvas2__2pf7H","Select":"HeaterCtrl_Select__2FFo8"};